import _ from 'lodash';
import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { getAllChoiceDescendants } from '@scale/shared/annotation';
import { LabelChoice, getLabelChoiceValue } from '@scale/shared/types/params/annotation';
import AttributeShortcutInput from './AttributeShortcutInput';

interface AttributeShortcutSelectProps {
  tree: LabelChoice;
  isReadOnly?: boolean;
  selectedChoice?: string;
  handleSelect?: (choice: string) => void;
  index: number;
  isFocused?: boolean;
}

interface AttributeShortcutSelectState {
  expanded: boolean;
}

export default class AttributeShortcutSelect extends React.Component<
  AttributeShortcutSelectProps,
  AttributeShortcutSelectState
> {
  state: AttributeShortcutSelectState = {
    expanded: false,
  };

  componentDidMount() {
    this.expandToSelectedDescendant();
  }

  // originally componentWillReceiveProps
  componentDidUpdate() {
    this.expandToSelectedDescendant();
  }

  expandToSelectedDescendant() {
    let subchoices: LabelChoice[];
    if (_.isString(this.props.tree)) {
      subchoices = [];
    } else {
      subchoices = this.props.tree.subchoices || [];
    }
    const descendants = getAllChoiceDescendants(subchoices);

    if (_.includes(descendants, this.props.selectedChoice)) {
      this.handleExpand();
    }
  }

  handleExpand = () => {
    this.setState({
      expanded: true,
    });
  };

  handleToggleExpanded = () => {
    this.setState(prevState => {
      return {
        expanded: !prevState.expanded,
      };
    });
  };

  render() {
    let categoryDisplayName: string;
    let categoryChildren: LabelChoice[];
    if (_.isString(this.props.tree)) {
      categoryDisplayName = this.props.tree;
      categoryChildren = [];
    } else {
      categoryDisplayName = this.props.tree.display || this.props.tree.choice;
      categoryChildren = this.props.tree.subchoices || [];
    }

    if (_.isEmpty(categoryChildren) && this.props.handleSelect) {
      return (
        <AttributeShortcutInput
          choice={this.props.tree}
          selectedChoice={this.props.selectedChoice}
          isReadOnly={this.props.isReadOnly}
          handleSelect={this.props.handleSelect}
          index={this.props.index}
          isFocused={this.props.isFocused}
        />
      );
    }

    return (
      <div className="radio-selector__tree">
        <div className="radio-selector__heading" onClick={this.handleToggleExpanded}>
          <div>
            {!this.state.expanded && (
              <FontAwesomeIcon
                icon="chevron-right"
                style={{ marginRight: '10px', fontSize: '14px' }}
              />
            )}
          </div>
          <div>
            {this.state.expanded && (
              <FontAwesomeIcon
                icon="chevron-down"
                style={{ marginRight: '10px', fontSize: '14px' }}
              />
            )}
          </div>
          {categoryDisplayName}
        </div>

        <div className="radio-selector__leaves">
          {this.state.expanded &&
            categoryChildren.map((c, idx) => (
              <AttributeShortcutSelect
                key={getLabelChoiceValue(c)}
                tree={c}
                selectedChoice={this.props.selectedChoice}
                isReadOnly={this.props.isReadOnly}
                handleSelect={this.props.handleSelect}
                index={idx}
                isFocused={this.props.isFocused}
              />
            ))}
        </div>

        <style jsx>{`
          .radio-selector__tree {
            padding-left: 8px;
            margin-bottom: 4px;
          }

          .radio-selector__heading {
            padding: 4px 0;
            margin-bottom: 4px;
            cursor: pointer;
            color: rgba(0, 0, 0, 0.7);
            transition: color 0.3s;
          }

          .radio-selector__heading:hover {
            color: rgba(0, 0, 0, 1);
          }

          .radio-selector__leaves {
            padding-left: 8px;
          }
        `}</style>
      </div>
    );
  }
}
